import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAutomationRoute: InvariantJiraRoute = {
	name: 'project-settings-core-automation',
	path: '/jira/core/projects/:projectKey/settings/automation',
};
